import React, { useEffect, useState } from "react";
import { StatusCode } from "api/protocols";
import Card from "components/card/Card";
import Input from "components/form/input/Input";
import Page from "components/page/Page";
import { useAppDispatch } from "hooks/redux";
import { useHistory } from "react-router";
import { showError, showSuccess } from "redux/actions/ui";

import { useTranslation, Trans } from "react-i18next";
import { loadFacilityKitchenCourses } from "redux/actions/facility";
import { PostKitchenMeal } from "api/rpc/2024-04/facilityAdmin/facility/kitchen/meals";
interface IState {
  title: string;
}

export default function KitchenMealNew(props: any) {
  const [state, setState] = useState<IState>({
    title: "",
  });

  const dispatch = useAppDispatch();
  const history = useHistory();
  const { t, i18n } = useTranslation();
  function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { id, value } = e.target;
    setState(prevState => ({ ...prevState, [id]: value }));
  }

  async function createNewCourse() {
    const saveMealRes = await PostKitchenMeal({ title: state?.title }, true);
    if (saveMealRes?.status !== StatusCode.OK) {
      dispatch(showError(t("Error creating new menu group")));
      return;
    }
    dispatch(showSuccess(t("Successfully created new menu group")));
    //Reload courses in redux
    await dispatch(loadFacilityKitchenCourses(null, true));
    history.push("/admin/settings/courses");
  }

  const primaryAction = {
    content: t("Save"),
    action: createNewCourse,
  };

  return (
    <Page
      title={t("New Menu Group")}
      breadcrumbs={[
        {
          prefix: true,
          label: t("Back to Menu Groups"),
          url: "/admin/settings/courses",
        },
      ]}
      primaryAction={primaryAction}
      narrow
    >
      <Card>
        <Card.Section>
          <Input
            label={t("Title")}
            placeholder={t("Title")}
            id="title"
            value={state?.title ?? ""}
            onChange={handleInputChange}
          />
        </Card.Section>
      </Card>
    </Page>
  );
}
